export const defaultUserInfoConstant = {
  id: '',
  customerId: null,
  userName: '',
  sites: null,
  permission: '',
  email: '',
};